import React from 'react';
import './BaseComponent.scss';



function BaseComponent(props) {
    let image = '';
    switch (props.vendor_id){
        case '27293':
        case '027293':
            image = 'https://s3.emmezeta.hr/falcon/kitchenComposition/Bazna_kompozicija_HR_NOBILIA_KUHINJE.png';
            break
        case '3613':
            image='https://s3.emmezeta.hr/falcon/kitchenComposition/Bazna_kompozicija_RS_NOBILIA_KUHINJE.png'
            break
        case '183812':
            image = 'https://s3.emmezeta.hr/falcon/kitchenComposition/Bazna_kompozicija_HR_NOLTE_KUHINJE.jpg';
            break;
        case '16922':
            image = 'https://s3.emmezeta.hr/falcon/kitchenComposition/Bazna_kompozicija_RS_NOLTE_KUHINJE.jpg';
            break
        default:
            image='https://s3.emmezeta.hr/falcon/kitchenComposition/Bazna_kompozicija_HR_ARAN_KUHINJE.png';
    }

    return (
        <div>
            <div onClick={props.closeComponent} className="background"/>
            <div className="baseComponentContent">
                <h2 className="title">
                    Bazna kompozicija
                </h2>
                <img src={image} alt=""/>
                <div onClick={props.closeComponent} className="closeButton"/>
            </div>
        </div>
    )
}

export default BaseComponent;
